import { useState, useMemo } from 'react'
import dayjs from 'dayjs'

export const useDateRangeLogic = (initialStartDate, initialEndDate) => {
  const [dateRangeMode, setDateRangeMode] = useState('monthly')
  const [dialogStartDate, setDialogStartDate] = useState(dayjs(initialStartDate))
  const [customDateRange, setCustomDateRange] = useState([
    dayjs(initialStartDate).toDate(),
    dayjs(initialEndDate).add(1, 'week').toDate()
  ])

  const getReportDateRange = useMemo(() => {
    if (dateRangeMode === 'monthly') {
      return {
        start: dialogStartDate.clone().startOf('month'),
        end: dialogStartDate.clone().endOf('month')
      }
    } else {
      return {
        start: dayjs(customDateRange[0]).startOf('day'),
        end: dayjs(customDateRange[1]).endOf('day')
      }
    }
  }, [dateRangeMode, dialogStartDate, customDateRange])

  const isValidDateRange = useMemo(() => {
    if (dateRangeMode === 'monthly') {
      return dialogStartDate && dialogStartDate.isValid()
    }
    return customDateRange && customDateRange[0] && customDateRange[1] && 
           dayjs(customDateRange[0]).isBefore(dayjs(customDateRange[1])) 
  }, [dateRangeMode, dialogStartDate, customDateRange])

  const generateFileName = (fileNamePrefix) => {
    if (dateRangeMode === 'monthly') {
      const formattedStartDate = dialogStartDate.clone().startOf('month').format('MMM-YYYY')
      return `${fileNamePrefix}_${formattedStartDate}.xlsx`
    } else {
      const formattedStartDate = dayjs(customDateRange[0]).format('DD-MMM-YYYY')
      const formattedEndDate = dayjs(customDateRange[1]).format('DD-MMM-YYYY')
      return `${fileNamePrefix}_${formattedStartDate}_to_${formattedEndDate}.xlsx`
    }
  }

  return {
    dateRangeMode,
    setDateRangeMode,
    dialogStartDate,
    setDialogStartDate,
    customDateRange,
    setCustomDateRange,
    getReportDateRange,
    isValidDateRange,
    generateFileName
  }
}
